/* POCIKA theme scripts */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var toggle = document.querySelector('[data-drawer-open]');
    var drawer = document.getElementById('MobileDrawer');
    var overlay = document.getElementById('Overlay');
    if (!toggle || !drawer) return;
    function open() { drawer.classList.add('is-open'); overlay && overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); overlay && overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
    toggle.addEventListener('click', open);
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay && overlay.addEventListener('click', close);
  }

  /* ---------- Carousels ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (car) {
      var track = car.querySelector('[data-carousel-track]');
      var prev = car.querySelector('[data-carousel-prev]');
      var next = car.querySelector('[data-carousel-next]');
      if (!track) return;
      function step() {
        var first = track.querySelector('*');
        var w = first ? first.getBoundingClientRect().width + 18 : 240;
        return Math.max(w, Math.round(track.clientWidth * 0.8));
      }
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
      var btns = wrap.querySelectorAll('[data-tab]');
      var panels = wrap.querySelectorAll('[data-panel]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-tab');
          btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === id); });
        });
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]'));
    var current = 0;
    function show(i) {
      if (!thumbs.length) return;
      current = (i + thumbs.length) % thumbs.length;
      var thumb = thumbs[current];
      var src = thumb.getAttribute('data-full');
      if (src) main.src = src;
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === current); });
    }
    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () { show(idx); });
    });
    var prev = document.querySelector('[data-gallery-prev]');
    var next = document.querySelector('[data-gallery-next]');
    prev && prev.addEventListener('click', function () { show(current - 1); });
    next && next.addEventListener('click', function () { show(current + 1); });
  }

  /* ---------- Quantity ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelector('[data-qty-minus]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      wrap.querySelector('[data-qty-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });
  }

  /* ---------- Quote modal ---------- */
  function initModal() {
    var modal = document.getElementById('QuoteModal');
    if (!modal) return;
    var productField = modal.querySelector('[data-modal-product]');
    function open(productName) {
      if (productField && productName) productField.value = productName;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-quote-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open(btn.getAttribute('data-product') || '');
      });
    });
    modal.querySelectorAll('[data-modal-close]').forEach(function (b) { b.addEventListener('click', close); });
  }

  /* ---------- Scroll to top ---------- */
  function initScrollTop() {
    var btn = document.querySelector('[data-scroll-top]');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 500);
    });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initCarousels();
    initTabs();
    initGallery();
    initQty();
    initModal();
    initScrollTop();
  });
})();
